<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết nhóm người dùng</h1>
      <div style="float: right">
        <button
          v-if="userName != '' && groupOwner.includes(userName)"
          type="button"
          @click="$router.push(`/customer-support/group-user/edit/${info.id}`)"
          class="btn btn-light"
        >
          Cập nhật
        </button>
        <button
          type="button"
          class="btn btn-light ml-2"
          v-if="info.status === 'OPEN'"
          @click="changeStatus('CLOSE')"
        >
          Khóa
        </button>
        <button
          type="button"
          class="btn btn-light ml-2"
          v-if="info.status === 'CLOSE'"
          @click="changeStatus('OPEN')"
        >
          Mở khóa
        </button>
      </div>
    </div>

    <div class="card-body">
      <div class="row px-20 b-t-1-869fb229 pt-15">
        <div class="col-md-6 px-1">
          <div class="form-detail" style="overflow-wrap: break-word">
            <h1>Thông tin chung</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã nhóm <span class="float-right">:</span>
              </label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ info.code ?? '' }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tên nhóm <span class="float-right">:</span>
              </label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ info.name ?? '' }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Thời gian tạo <span class="float-right">:</span>
              </label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ info.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Người tạo <span class="float-right">:</span>
              </label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ info.createdBy ?? '' }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Người sở hữu <span class="float-right">:</span>
              </label>
              <div class="col-sm-8">
                <div class="form-control-plaintext f12">
                  <div v-html="formattedArray(info.groupOwner)"></div>
                </div>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Trạng thái <span class="float-right">:</span>
              </label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span
                    class="badge"
                    :class="info.status ? getColor(info.status, optionColorStatus) : ''"
                    >{{ info.status ? joinArrayData(info.status, optionStatus) : '' }}</span
                  >
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mô tả <span class="float-right">:</span>
              </label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ info.description ?? '' }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Thời gian cập nhật <span class="float-right">:</span>
              </label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ info.lastModifiedDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-content p-10" id="nav-tabContent">
        <div class="box-header">
          <span class="fonsize-16"><strong>Danh sách nhân viên nhóm </strong></span>
          <input
            v-model="txtSearch"
            type="text"
            class="input-search d-inline-block"
            style="width: 200px; height: 25px; text-indent: 5px"
            placeholder="🔎 Từ khóa"
          />
        </div>
        <b-table
          :busy.sync="loading"
          sticky-header
          hover
          responsive
          :items="tableDataShow"
          :fields="filterTable"
          :fixed="true"
          :bordered="true"
        >
          <template #table-busy>
            <div class="my-2 text-center">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #cell(index)="data">
            {{ getIndex(data.index) }}
          </template>
          <template #cell(staff)="data">
            <p>
              {{ data.item.name ?? '' }}
              {{ data.item.companyCode && data.item.name ? '- ' + data.item.companyCode : '' }}
            </p>
            <p>{{ data.item.email ?? '' }}</p>
          </template>
          <template #cell(position)="data">
            <p>
              {{
                data.item.position ? joinArrayData(data.item.position, positionMemberOption) : ''
              }}
            </p>
          </template>
        </b-table>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { Detail, UpdateStatus } from '@/services/customer-support/group-user'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'staff', label: 'Nhân viên', class: 'text-center' },
    { key: 'position', label: 'Chức vụ ( trong nhóm)', class: 'text-center' },
  ]
  export default {
    data() {
      return {
        filterTable: fieldsTable,
        info: {
          id: '',
          code: '',
          name: '',
          description: '',
          teamUsers: [],
          status: '',
          createdDate: '',
          createdBy: '',
        },
        optionStatus: [
          { id: 'OPEN', text: 'Đang hoạt động' },
          { id: 'CLOSE', text: 'Khóa' },
        ],
        optionColorStatus: {
          OPEN: 'success',
          CLOSE: 'danger',
        },
        loading: false,
        showLoading: false,
        lists: [],
        search: {
          page: 1,
          limit: 10,
        },
        positionMemberOption: [
          { id: 'MEMBER', text: 'Thành viên' },
          { id: 'TEAMOWNERSHIP', text: 'Sở hữu nhóm' },
        ],
        txtSearch: '',
        userName: JSON.parse(localStorage.getItem('userData')).username ?? '',
        groupOwner: [],
      }
    },
    created() {
      this.info.id = this.$router.currentRoute.params.id ?? ''
      this.fetchData()
    },
    computed: {
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
      getColor() {
        return (code, option) => {
          if (!code) return code
          return option[code] ? option[code] : code
        }
      },
      tableDataShow() {
        const txt = this.txtSearch.trim().toLocaleLowerCase()
        return txt
          ? this.lists.filter(
              row =>
                (row.email || '').toLocaleLowerCase().indexOf(txt) >= 0 ||
                (row.name || '').toLocaleLowerCase().indexOf(txt) >= 0
            )
          : this.lists
      },
      formattedArray() {
        return array => {
          if (!array || array.length === 0) return ''
          return array.join('<br>')
        }
      },
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = true
          const response = await Detail({ id: this.info.id })
          if (response.code === 1000 && response.data) {
            this.info.code = response.data.code ?? ''
            this.info.name = response.data.name ?? ''
            this.info.description = response.data.description ?? ''
            this.info.teamUsers = response.data.teamUsers ?? []
            this.info.status = response.data.status ?? ''
            this.info.createdDate = response.data.createdDate ?? ''
            this.info.createdBy = response.data.createdBy ?? ''
            this.info.groupOwner = response.data.groupOwner ?? ''
            this.info.lastModifiedDate = response.data.lastModifiedDate ?? ''
            this.groupOwner = this.info.teamUsers.reduce((acc, current) => {
              if (current.position === 'TEAMOWNERSHIP') {
                acc.push(current.email)
              }
              return acc
            }, [])
            this.lists = this.info.teamUsers
            if (this.lists.length > 0) {
              this.lists.sort((a, b) => {
                if (a.position === 'TEAMOWNERSHIP' && b.position !== 'TEAMOWNERSHIP') {
                  return -1
                }
                if (a.position !== 'TEAMOWNERSHIP' && b.position === 'TEAMOWNERSHIP') {
                  return 1
                }
                return 0
              })
            }
            this.search.limit = this.lists.length
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async changeStatus(status) {
        const flag = await this.approveMx('Nhấn Xác nhận để chuyển trạng thái!')
        if (flag !== true) return

        try {
          this.showLoading = true
          const response = await UpdateStatus({
            id: this.info.id,
            status: status,
          })
          if (response.code === 1000) {
            this.showSuccessMx('Chuyển trạng thái thành công')
            this.fetchData()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
<style scoped>
  .success {
    color: #fff;
    background-color: #28a745;
  }

  .danger {
    color: #fff;
    background-color: #dc3545;
  }
</style>
